import EnumClass, { build } from '../EnumClass';
import data, { DictionaryTagId, DictionaryTagData } from './data';
import * as Translations from './translations';

export class DictionaryTag extends EnumClass<DictionaryTagId, DictionaryTagData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: DICTIONARY_TAGS,
  getById: getDictionaryTagById,
  marshaller: DictionaryTagMarshaller,
} = build<DictionaryTagId, DictionaryTagData, DictionaryTag>('DictionaryTagEnum', data, DictionaryTag);
